export const DEMANDE_VISUEL = 'DemandeVisuel';
export const ENVOIE_BAT = 'EnvoieBat';
export const ATTENTE_RETOUR_BAT = 'AttenteRetourBat';
export const BAT_SIGNE = 'BatSigne';
export const TRANSMI_PAO = 'TransmisPAO';
export const VALIDATION_VRP = 'ValidationVRP';

export const ETAT_BAT = [
  { key: DEMANDE_VISUEL, libelle: 'ajoutPresseDcf.etatBat.demandeVisuel' },
  { key: TRANSMI_PAO, libelle: 'ajoutPresseDcf.etatBat.transmisPAO' },
  { key: VALIDATION_VRP, libelle: 'ajoutPresseDcf.etatBat.validationVRP' },
  { key: ENVOIE_BAT, libelle: 'ajoutPresseDcf.etatBat.envoieBat' },
  { key: ATTENTE_RETOUR_BAT, libelle: 'ajoutPresseDcf.etatBat.attenteRetourBat' },
  { key: BAT_SIGNE, libelle: 'ajoutPresseDcf.etatBat.batSigne' },
];

export const EXPORT_EXCEL_ENCARTS_PRODUIT = 'encartsproduit';
export const EXPORT_EXCEL_REGLES_ACHAT = 'reglesachatproduit';
export const EXPORT_EXCEL_COMMISSIONS_VENDEUR = 'commsissionsvendeurproduit';
export const EXPORT_EXCEL_CGV = 'cgvsproduit';
export const EXPORT_EXCEL_OBJECTIF_VENTE = 'objectifsventeproduit';
export const EXPORT_EXCEL_PRESTATION = 'prestationproduit';
